var cov_10r43dfprg = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/agencies/agenciesCtrl.js',
      hash = '97644a08b2294fec54b0130cb732e61f0f06a709',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/agencies/agenciesCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 16
        },
        end: {
          line: 1,
          column: 18
        }
      },
      '1': {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 139,
          column: 3
        }
      },
      '2': {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 3,
          column: 38
        }
      },
      '3': {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      },
      '4': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 11
        }
      },
      '5': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 9,
          column: 4
        }
      },
      '6': {
        start: {
          line: 10,
          column: 15
        },
        end: {
          line: 10,
          column: 32
        }
      },
      '7': {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 22,
          column: 4
        }
      },
      '8': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 28
        }
      },
      '9': {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 21,
          column: 7
        }
      },
      '10': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 18,
          column: 7
        }
      },
      '11': {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 56
        }
      },
      '12': {
        start: {
          line: 16,
          column: 26
        },
        end: {
          line: 16,
          column: 100
        }
      },
      '13': {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 37
        }
      },
      '14': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 25
        }
      },
      '15': {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 31
        }
      },
      '16': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 30,
          column: 5
        }
      },
      '17': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 29,
          column: 7
        }
      },
      '18': {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 45,
          column: 4
        }
      },
      '19': {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 44,
          column: 7
        }
      },
      '20': {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 87,
          column: 4
        }
      },
      '21': {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 77,
          column: 7
        }
      },
      '22': {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 29
        }
      },
      '23': {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 21
        }
      },
      '24': {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 81,
          column: 7
        }
      },
      '25': {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 79,
          column: 29
        }
      },
      '26': {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 40
        }
      },
      '27': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 85,
          column: 7
        }
      },
      '28': {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 29
        }
      },
      '29': {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 42
        }
      },
      '30': {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 104,
          column: 4
        }
      },
      '31': {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 30
        }
      },
      '32': {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 53
        }
      },
      '33': {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 109
        }
      },
      '34': {
        start: {
          line: 94,
          column: 78
        },
        end: {
          line: 94,
          column: 107
        }
      },
      '35': {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 103,
          column: 7
        }
      },
      '36': {
        start: {
          line: 106,
          column: 2
        },
        end: {
          line: 136,
          column: 4
        }
      },
      '37': {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 135,
          column: 7
        }
      },
      '38': {
        start: {
          line: 119,
          column: 6
        },
        end: {
          line: 121,
          column: 7
        }
      },
      '39': {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 120,
          column: 15
        }
      },
      '40': {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 122,
          column: 30
        }
      },
      '41': {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 134,
          column: 9
        }
      },
      '42': {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 132,
          column: 9
        }
      },
      '43': {
        start: {
          line: 125,
          column: 10
        },
        end: {
          line: 125,
          column: 35
        }
      },
      '44': {
        start: {
          line: 126,
          column: 10
        },
        end: {
          line: 129,
          column: 13
        }
      },
      '45': {
        start: {
          line: 131,
          column: 10
        },
        end: {
          line: 131,
          column: 17
        }
      },
      '46': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 24
        }
      },
      '47': {
        start: {
          line: 138,
          column: 2
        },
        end: {
          line: 138,
          column: 18
        }
      },
      '48': {
        start: {
          line: 147,
          column: 2
        },
        end: {
          line: 147,
          column: 28
        }
      },
      '49': {
        start: {
          line: 148,
          column: 15
        },
        end: {
          line: 148,
          column: 32
        }
      },
      '50': {
        start: {
          line: 149,
          column: 2
        },
        end: {
          line: 164,
          column: 4
        }
      },
      '51': {
        start: {
          line: 150,
          column: 25
        },
        end: {
          line: 150,
          column: 66
        }
      },
      '52': {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 27
        }
      },
      '53': {
        start: {
          line: 152,
          column: 18
        },
        end: {
          line: 152,
          column: 87
        }
      },
      '54': {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 158,
          column: 5
        }
      },
      '55': {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 157,
          column: 7
        }
      },
      '56': {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 155,
          column: 38
        }
      },
      '57': {
        start: {
          line: 156,
          column: 8
        },
        end: {
          line: 156,
          column: 15
        }
      },
      '58': {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 159,
          column: 57
        }
      },
      '59': {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 163,
          column: 7
        }
      },
      '60': {
        start: {
          line: 161,
          column: 6
        },
        end: {
          line: 161,
          column: 26
        }
      },
      '61': {
        start: {
          line: 162,
          column: 6
        },
        end: {
          line: 162,
          column: 22
        }
      },
      '62': {
        start: {
          line: 165,
          column: 2
        },
        end: {
          line: 167,
          column: 4
        }
      },
      '63': {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 40
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 49
          },
          end: {
            line: 2,
            column: 50
          }
        },
        loc: {
          start: {
            line: 2,
            column: 161
          },
          end: {
            line: 139,
            column: 1
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 11,
            column: 18
          },
          end: {
            line: 11,
            column: 19
          }
        },
        loc: {
          start: {
            line: 11,
            column: 30
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 11
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 13,
            column: 44
          },
          end: {
            line: 13,
            column: 45
          }
        },
        loc: {
          start: {
            line: 13,
            column: 52
          },
          end: {
            line: 21,
            column: 5
          }
        },
        line: 13
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 23
          }
        },
        loc: {
          start: {
            line: 24,
            column: 28
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 24
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 16
          }
        },
        loc: {
          start: {
            line: 32,
            column: 27
          },
          end: {
            line: 45,
            column: 3
          }
        },
        line: 32
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 89,
            column: 20
          },
          end: {
            line: 89,
            column: 21
          }
        },
        loc: {
          start: {
            line: 89,
            column: 36
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 89
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 94,
            column: 67
          },
          end: {
            line: 94,
            column: 68
          }
        },
        loc: {
          start: {
            line: 94,
            column: 78
          },
          end: {
            line: 94,
            column: 107
          }
        },
        line: 94
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 106,
            column: 22
          },
          end: {
            line: 106,
            column: 23
          }
        },
        loc: {
          start: {
            line: 106,
            column: 38
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 106
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 118,
            column: 7
          },
          end: {
            line: 118,
            column: 8
          }
        },
        loc: {
          start: {
            line: 118,
            column: 20
          },
          end: {
            line: 135,
            column: 5
          }
        },
        line: 118
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 123,
            column: 62
          },
          end: {
            line: 123,
            column: 63
          }
        },
        loc: {
          start: {
            line: 123,
            column: 70
          },
          end: {
            line: 134,
            column: 7
          }
        },
        line: 123
      },
      '10': {
        name: 'AgenciesCtrl_edit',
        decl: {
          start: {
            line: 141,
            column: 9
          },
          end: {
            line: 141,
            column: 26
          }
        },
        loc: {
          start: {
            line: 141,
            column: 77
          },
          end: {
            line: 168,
            column: 1
          }
        },
        line: 141
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 149,
            column: 24
          },
          end: {
            line: 149,
            column: 25
          }
        },
        loc: {
          start: {
            line: 149,
            column: 36
          },
          end: {
            line: 164,
            column: 3
          }
        },
        line: 149
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 160,
            column: 90
          },
          end: {
            line: 160,
            column: 91
          }
        },
        loc: {
          start: {
            line: 160,
            column: 96
          },
          end: {
            line: 163,
            column: 5
          }
        },
        line: 160
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 165,
            column: 22
          },
          end: {
            line: 165,
            column: 23
          }
        },
        loc: {
          start: {
            line: 165,
            column: 34
          },
          end: {
            line: 167,
            column: 3
          }
        },
        line: 165
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }, {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }],
        line: 4
      },
      '1': {
        loc: {
          start: {
            line: 16,
            column: 26
          },
          end: {
            line: 16,
            column: 100
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 16,
            column: 26
          },
          end: {
            line: 16,
            column: 86
          }
        }, {
          start: {
            line: 16,
            column: 90
          },
          end: {
            line: 16,
            column: 100
          }
        }],
        line: 16
      },
      '2': {
        loc: {
          start: {
            line: 48,
            column: 14
          },
          end: {
            line: 48,
            column: 61
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 48,
            column: 42
          },
          end: {
            line: 48,
            column: 49
          }
        }, {
          start: {
            line: 48,
            column: 52
          },
          end: {
            line: 48,
            column: 61
          }
        }],
        line: 48
      },
      '3': {
        loc: {
          start: {
            line: 69,
            column: 28
          },
          end: {
            line: 69,
            column: 141
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 69,
            column: 56
          },
          end: {
            line: 69,
            column: 136
          }
        }, {
          start: {
            line: 69,
            column: 139
          },
          end: {
            line: 69,
            column: 141
          }
        }],
        line: 69
      },
      '4': {
        loc: {
          start: {
            line: 70,
            column: 18
          },
          end: {
            line: 70,
            column: 134
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 70,
            column: 46
          },
          end: {
            line: 70,
            column: 129
          }
        }, {
          start: {
            line: 70,
            column: 132
          },
          end: {
            line: 70,
            column: 134
          }
        }],
        line: 70
      },
      '5': {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }, {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        }],
        line: 74
      },
      '6': {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }],
        line: 78
      },
      '7': {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 85,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 85,
            column: 7
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 85,
            column: 7
          }
        }],
        line: 82
      },
      '8': {
        loc: {
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 121,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 121,
            column: 7
          }
        }, {
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 121,
            column: 7
          }
        }],
        line: 119
      },
      '9': {
        loc: {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        }, {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        }],
        line: 124
      },
      '10': {
        loc: {
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 157,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 157,
            column: 7
          }
        }, {
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 157,
            column: 7
          }
        }],
        line: 154
      },
      '11': {
        loc: {
          start: {
            line: 154,
            column: 10
          },
          end: {
            line: 154,
            column: 44
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 154,
            column: 10
          },
          end: {
            line: 154,
            column: 14
          }
        }, {
          start: {
            line: 154,
            column: 18
          },
          end: {
            line: 154,
            column: 44
          }
        }],
        line: 154
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var COUNTRIES = (cov_10r43dfprg.s[0]++, []);
cov_10r43dfprg.s[1]++;
angular.module('app').controller('AgenciesCtrl', function ($scope, SweetAlert, $uibModal, $translate, $CRUDService, $otherHttpService, $location, $filter, $rootScope) {
  cov_10r43dfprg.f[0]++;
  cov_10r43dfprg.s[2]++;

  $rootScope.processPageRight('1_14');
  cov_10r43dfprg.s[3]++;
  if ($rootScope.global_access_page_denied) {
    cov_10r43dfprg.b[0][0]++;
    cov_10r43dfprg.s[4]++;

    return;
  } else {
    cov_10r43dfprg.b[0][1]++;
  }
  cov_10r43dfprg.s[5]++;
  $scope.countries = COUNTRIES = [{ id: 1, name: $translate.instant('COUNTRIES.AF') }, { id: 2, name: $translate.instant('COUNTRIES.AX') }, { id: 3, name: $translate.instant('COUNTRIES.AL') }, { id: 4, name: $translate.instant('COUNTRIES.DZ') }, { id: 5, name: $translate.instant('COUNTRIES.AS') }, { id: 6, name: $translate.instant('COUNTRIES.AD') }, { id: 7, name: $translate.instant('COUNTRIES.AO') }, { id: 8, name: $translate.instant('COUNTRIES.AI') }, { id: 9, name: $translate.instant('COUNTRIES.AQ') }, { id: 10, name: $translate.instant('COUNTRIES.AG') }, { id: 11, name: $translate.instant('COUNTRIES.AR') }, { id: 12, name: $translate.instant('COUNTRIES.AM') }, { id: 13, name: $translate.instant('COUNTRIES.AW') }, { id: 14, name: $translate.instant('COUNTRIES.AU') }, { id: 15, name: $translate.instant('COUNTRIES.AT') }, { id: 16, name: $translate.instant('COUNTRIES.AZ') }, { id: 17, name: $translate.instant('COUNTRIES.BS') }, { id: 18, name: $translate.instant('COUNTRIES.BH') }, { id: 19, name: $translate.instant('COUNTRIES.BD') }, { id: 20, name: $translate.instant('COUNTRIES.BB') }, { id: 21, name: $translate.instant('COUNTRIES.BY') }, { id: 22, name: $translate.instant('COUNTRIES.BE') }, { id: 23, name: $translate.instant('COUNTRIES.BZ') }, { id: 24, name: $translate.instant('COUNTRIES.BJ') }, { id: 25, name: $translate.instant('COUNTRIES.BM') }, { id: 26, name: $translate.instant('COUNTRIES.BT') }, { id: 27, name: $translate.instant('COUNTRIES.BO') }, { id: 28, name: $translate.instant('COUNTRIES.BA') }, { id: 29, name: $translate.instant('COUNTRIES.BW') }, { id: 30, name: $translate.instant('COUNTRIES.BV') }, { id: 31, name: $translate.instant('COUNTRIES.BR') }, { id: 32, name: $translate.instant('COUNTRIES.IO') }, { id: 33, name: $translate.instant('COUNTRIES.BN') }, { id: 34, name: $translate.instant('COUNTRIES.BG') }, { id: 35, name: $translate.instant('COUNTRIES.BF') }, { id: 36, name: $translate.instant('COUNTRIES.BI') }, { id: 37, name: $translate.instant('COUNTRIES.KH') }, { id: 38, name: $translate.instant('COUNTRIES.CM') }, { id: 39, name: $translate.instant('COUNTRIES.CA') }, { id: 40, name: $translate.instant('COUNTRIES.CV') }, { id: 41, name: $translate.instant('COUNTRIES.KY') }, { id: 42, name: $translate.instant('COUNTRIES.CF') }, { id: 43, name: $translate.instant('COUNTRIES.TD') }, { id: 44, name: $translate.instant('COUNTRIES.CL') }, { id: 45, name: $translate.instant('COUNTRIES.CN') }, { id: 46, name: $translate.instant('COUNTRIES.CX') }, { id: 47, name: $translate.instant('COUNTRIES.CC') }, { id: 48, name: $translate.instant('COUNTRIES.CO') }, { id: 49, name: $translate.instant('COUNTRIES.KM') }, { id: 50, name: $translate.instant('COUNTRIES.CG') }, { id: 51, name: $translate.instant('COUNTRIES.CD') }, { id: 52, name: $translate.instant('COUNTRIES.CK') }, { id: 53, name: $translate.instant('COUNTRIES.CR') }, { id: 54, name: $translate.instant('COUNTRIES.CI') }, { id: 55, name: $translate.instant('COUNTRIES.HR') }, { id: 56, name: $translate.instant('COUNTRIES.CU') }, { id: 57, name: $translate.instant('COUNTRIES.CY') }, { id: 58, name: $translate.instant('COUNTRIES.CZ') }, { id: 59, name: $translate.instant('COUNTRIES.DK') }, { id: 60, name: $translate.instant('COUNTRIES.DJ') }, { id: 61, name: $translate.instant('COUNTRIES.DM') }, { id: 62, name: $translate.instant('COUNTRIES.DO') }, { id: 63, name: $translate.instant('COUNTRIES.EC') }, { id: 64, name: $translate.instant('COUNTRIES.EG') }, { id: 65, name: $translate.instant('COUNTRIES.SV') }, { id: 66, name: $translate.instant('COUNTRIES.GQ') }, { id: 67, name: $translate.instant('COUNTRIES.ER') }, { id: 68, name: $translate.instant('COUNTRIES.EE') }, { id: 69, name: $translate.instant('COUNTRIES.ET') }, { id: 70, name: $translate.instant('COUNTRIES.FK') }, { id: 71, name: $translate.instant('COUNTRIES.FO') }, { id: 72, name: $translate.instant('COUNTRIES.FJ') }, { id: 73, name: $translate.instant('COUNTRIES.FI') }, { id: 74, name: $translate.instant('COUNTRIES.FR') }, { id: 75, name: $translate.instant('COUNTRIES.GF') }, { id: 76, name: $translate.instant('COUNTRIES.PF') }, { id: 77, name: $translate.instant('COUNTRIES.TF') }, { id: 78, name: $translate.instant('COUNTRIES.GA') }, { id: 79, name: $translate.instant('COUNTRIES.GM') }, { id: 80, name: $translate.instant('COUNTRIES.GE') }, { id: 81, name: $translate.instant('COUNTRIES.DE') }, { id: 82, name: $translate.instant('COUNTRIES.GH') }, { id: 83, name: $translate.instant('COUNTRIES.GI') }, { id: 84, name: $translate.instant('COUNTRIES.GR') }, { id: 85, name: $translate.instant('COUNTRIES.GL') }, { id: 86, name: $translate.instant('COUNTRIES.GD') }, { id: 87, name: $translate.instant('COUNTRIES.GP') }, { id: 88, name: $translate.instant('COUNTRIES.GU') }, { id: 89, name: $translate.instant('COUNTRIES.GT') }, { id: 90, name: $translate.instant('COUNTRIES.GG') }, { id: 91, name: $translate.instant('COUNTRIES.GN') }, { id: 92, name: $translate.instant('COUNTRIES.GW') }, { id: 93, name: $translate.instant('COUNTRIES.GY') }, { id: 94, name: $translate.instant('COUNTRIES.HT') }, { id: 95, name: $translate.instant('COUNTRIES.HM') }, { id: 96, name: $translate.instant('COUNTRIES.VA') }, { id: 97, name: $translate.instant('COUNTRIES.HN') }, { id: 98, name: $translate.instant('COUNTRIES.HK') }, { id: 99, name: $translate.instant('COUNTRIES.HU') }, { id: 100, name: $translate.instant('COUNTRIES.IS') }, { id: 101, name: $translate.instant('COUNTRIES.IN') }, { id: 102, name: $translate.instant('COUNTRIES.ID') }, { id: 103, name: $translate.instant('COUNTRIES.IR') }, { id: 104, name: $translate.instant('COUNTRIES.IQ') }, { id: 105, name: $translate.instant('COUNTRIES.IE') }, { id: 106, name: $translate.instant('COUNTRIES.IM') }, { id: 107, name: $translate.instant('COUNTRIES.IL') }, { id: 108, name: $translate.instant('COUNTRIES.IT') }, { id: 109, name: $translate.instant('COUNTRIES.JM') }, { id: 110, name: $translate.instant('COUNTRIES.JP') }, { id: 111, name: $translate.instant('COUNTRIES.JE') }, { id: 112, name: $translate.instant('COUNTRIES.JO') }, { id: 113, name: $translate.instant('COUNTRIES.KZ') }, { id: 114, name: $translate.instant('COUNTRIES.KE') }, { id: 115, name: $translate.instant('COUNTRIES.KI') }, { id: 116, name: $translate.instant('COUNTRIES.KP') }, { id: 117, name: $translate.instant('COUNTRIES.KR') }, { id: 118, name: $translate.instant('COUNTRIES.KW') }, { id: 119, name: $translate.instant('COUNTRIES.KG') }, { id: 120, name: $translate.instant('COUNTRIES.LA') }, { id: 121, name: $translate.instant('COUNTRIES.LV') }, { id: 122, name: $translate.instant('COUNTRIES.LB') }, { id: 123, name: $translate.instant('COUNTRIES.LS') }, { id: 124, name: $translate.instant('COUNTRIES.LR') }, { id: 125, name: $translate.instant('COUNTRIES.LY') }, { id: 126, name: $translate.instant('COUNTRIES.LI') }, { id: 127, name: $translate.instant('COUNTRIES.LT') }, { id: 128, name: $translate.instant('COUNTRIES.LU') }, { id: 129, name: $translate.instant('COUNTRIES.MO') }, { id: 130, name: $translate.instant('COUNTRIES.MK') }, { id: 131, name: $translate.instant('COUNTRIES.MG') }, { id: 132, name: $translate.instant('COUNTRIES.MW') }, { id: 133, name: $translate.instant('COUNTRIES.MY') }, { id: 134, name: $translate.instant('COUNTRIES.MV') }, { id: 135, name: $translate.instant('COUNTRIES.ML') }, { id: 136, name: $translate.instant('COUNTRIES.MT') }, { id: 137, name: $translate.instant('COUNTRIES.MH') }, { id: 138, name: $translate.instant('COUNTRIES.MQ') }, { id: 139, name: $translate.instant('COUNTRIES.MR') }, { id: 140, name: $translate.instant('COUNTRIES.MU') }, { id: 141, name: $translate.instant('COUNTRIES.YT') }, { id: 142, name: $translate.instant('COUNTRIES.MX') }, { id: 143, name: $translate.instant('COUNTRIES.FM') }, { id: 144, name: $translate.instant('COUNTRIES.MD') }, { id: 145, name: $translate.instant('COUNTRIES.MC') }, { id: 146, name: $translate.instant('COUNTRIES.MN') }, { id: 147, name: $translate.instant('COUNTRIES.MS') }, { id: 148, name: $translate.instant('COUNTRIES.MA') }, { id: 149, name: $translate.instant('COUNTRIES.MZ') }, { id: 150, name: $translate.instant('COUNTRIES.MM') }, { id: 151, name: $translate.instant('COUNTRIES.NA') }, { id: 152, name: $translate.instant('COUNTRIES.NR') }, { id: 153, name: $translate.instant('COUNTRIES.NP') }, { id: 154, name: $translate.instant('COUNTRIES.NL') }, { id: 155, name: $translate.instant('COUNTRIES.AN') }, { id: 156, name: $translate.instant('COUNTRIES.NC') }, { id: 157, name: $translate.instant('COUNTRIES.NZ') }, { id: 158, name: $translate.instant('COUNTRIES.NI') }, { id: 159, name: $translate.instant('COUNTRIES.NE') }, { id: 160, name: $translate.instant('COUNTRIES.NG') }, { id: 161, name: $translate.instant('COUNTRIES.NU') }, { id: 162, name: $translate.instant('COUNTRIES.NF') }, { id: 163, name: $translate.instant('COUNTRIES.MP') }, { id: 164, name: $translate.instant('COUNTRIES.NO') }, { id: 165, name: $translate.instant('COUNTRIES.OM') }, { id: 166, name: $translate.instant('COUNTRIES.PK') }, { id: 167, name: $translate.instant('COUNTRIES.PW') }, { id: 168, name: $translate.instant('COUNTRIES.PS') }, { id: 169, name: $translate.instant('COUNTRIES.PA') }, { id: 170, name: $translate.instant('COUNTRIES.PG') }, { id: 171, name: $translate.instant('COUNTRIES.PY') }, { id: 172, name: $translate.instant('COUNTRIES.PE') }, { id: 173, name: $translate.instant('COUNTRIES.PH') }, { id: 174, name: $translate.instant('COUNTRIES.PN') }, { id: 175, name: $translate.instant('COUNTRIES.PL') }, { id: 176, name: $translate.instant('COUNTRIES.PT') }, { id: 177, name: $translate.instant('COUNTRIES.PR') }, { id: 178, name: $translate.instant('COUNTRIES.QA') }, { id: 179, name: $translate.instant('COUNTRIES.RE') }, { id: 180, name: $translate.instant('COUNTRIES.RO') }, { id: 181, name: $translate.instant('COUNTRIES.RU') }, { id: 182, name: $translate.instant('COUNTRIES.RW') }, { id: 183, name: $translate.instant('COUNTRIES.SH') }, { id: 184, name: $translate.instant('COUNTRIES.KN') }, { id: 185, name: $translate.instant('COUNTRIES.LC') }, { id: 186, name: $translate.instant('COUNTRIES.PM') }, { id: 187, name: $translate.instant('COUNTRIES.VC') }, { id: 188, name: $translate.instant('COUNTRIES.WS') }, { id: 189, name: $translate.instant('COUNTRIES.SM') }, { id: 190, name: $translate.instant('COUNTRIES.ST') }, { id: 191, name: $translate.instant('COUNTRIES.SA') }, { id: 192, name: $translate.instant('COUNTRIES.SN') }, { id: 193, name: $translate.instant('COUNTRIES.CS') }, { id: 194, name: $translate.instant('COUNTRIES.SC') }, { id: 195, name: $translate.instant('COUNTRIES.SL') }, { id: 196, name: $translate.instant('COUNTRIES.SG') }, { id: 197, name: $translate.instant('COUNTRIES.SK') }, { id: 198, name: $translate.instant('COUNTRIES.SI') }, { id: 199, name: $translate.instant('COUNTRIES.SB') }, { id: 200, name: $translate.instant('COUNTRIES.SO') }, { id: 201, name: $translate.instant('COUNTRIES.ZA') }, { id: 202, name: $translate.instant('COUNTRIES.GS') }, { id: 203, name: $translate.instant('COUNTRIES.ES') }, { id: 204, name: $translate.instant('COUNTRIES.LK') }, { id: 205, name: $translate.instant('COUNTRIES.SD') }, { id: 206, name: $translate.instant('COUNTRIES.SR') }, { id: 207, name: $translate.instant('COUNTRIES.SJ') }, { id: 208, name: $translate.instant('COUNTRIES.SZ') }, { id: 209, name: $translate.instant('COUNTRIES.SE') }, { id: 210, name: $translate.instant('COUNTRIES.CH') }, { id: 211, name: $translate.instant('COUNTRIES.SY') }, { id: 212, name: $translate.instant('COUNTRIES.TW') }, { id: 213, name: $translate.instant('COUNTRIES.TJ') }, { id: 214, name: $translate.instant('COUNTRIES.TZ') }, { id: 215, name: $translate.instant('COUNTRIES.TH') }, { id: 216, name: $translate.instant('COUNTRIES.TL') }, { id: 217, name: $translate.instant('COUNTRIES.TG') }, { id: 218, name: $translate.instant('COUNTRIES.TK') }, { id: 219, name: $translate.instant('COUNTRIES.TO') }, { id: 220, name: $translate.instant('COUNTRIES.TT') }, { id: 221, name: $translate.instant('COUNTRIES.TN') }, { id: 222, name: $translate.instant('COUNTRIES.TR') }, { id: 223, name: $translate.instant('COUNTRIES.TM') }, { id: 224, name: $translate.instant('COUNTRIES.TC') }, { id: 225, name: $translate.instant('COUNTRIES.TV') }, { id: 226, name: $translate.instant('COUNTRIES.UG') }, { id: 227, name: $translate.instant('COUNTRIES.UA') }, { id: 228, name: $translate.instant('COUNTRIES.AE') }, { id: 229, name: $translate.instant('COUNTRIES.GB') }, { id: 230, name: $translate.instant('COUNTRIES.US') }, { id: 231, name: $translate.instant('COUNTRIES.UM') }, { id: 232, name: $translate.instant('COUNTRIES.UY') }, { id: 233, name: $translate.instant('COUNTRIES.UZ') }, { id: 234, name: $translate.instant('COUNTRIES.VU') }, { id: 235, name: $translate.instant('COUNTRIES.VE') }, { id: 236, name: $translate.instant('COUNTRIES.VN') }, { id: 237, name: $translate.instant('COUNTRIES.VG') }, { id: 238, name: $translate.instant('COUNTRIES.VI') }, { id: 239, name: $translate.instant('COUNTRIES.WF') }, { id: 240, name: $translate.instant('COUNTRIES.EH') }, { id: 241, name: $translate.instant('COUNTRIES.YE') }, { id: 242, name: $translate.instant('COUNTRIES.ZM') }, { id: 243, name: $translate.instant('COUNTRIES.ZW') }];
  var PATH = (cov_10r43dfprg.s[6]++, 'AgenciesProject');
  cov_10r43dfprg.s[7]++;
  $scope.getAll = function () {
    cov_10r43dfprg.f[1]++;
    cov_10r43dfprg.s[8]++;

    $scope.isloading = true;
    cov_10r43dfprg.s[9]++;
    $CRUDService.getAll(PATH, { get: 'all' }, function (data) {
      cov_10r43dfprg.f[2]++;
      cov_10r43dfprg.s[10]++;

      for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var item = _ref;
        cov_10r43dfprg.s[11]++;

        item.COUNTRY_AG = parseInt(item.COUNTRY_AG, 10);
        var locality = (cov_10r43dfprg.s[12]++, (cov_10r43dfprg.b[1][0]++, $filter('filter')(COUNTRIES, { id: item.COUNTRY_AG }, true)[0]) || (cov_10r43dfprg.b[1][1]++, { name: '' }));
        cov_10r43dfprg.s[13]++;
        item.COUNTRY = locality.name;
      }
      cov_10r43dfprg.s[14]++;
      $scope.data = data;
      cov_10r43dfprg.s[15]++;
      $scope.isloading = false;
    });
  };

  cov_10r43dfprg.s[16]++;
  $scope.printData = function () {
    cov_10r43dfprg.f[3]++;
    cov_10r43dfprg.s[17]++;

    $rootScope.printReport({
      link: PATH,
      params: { get: 'print' },
      title: $translate.instant('MENU_SHORT.AGENCIES')
    });
  };

  cov_10r43dfprg.s[18]++;
  $scope.add = function () {
    cov_10r43dfprg.f[4]++;
    cov_10r43dfprg.s[19]++;

    $scope.editItem({
      NAME_AG: '',
      SHORT_NAME_AG: '',
      ADDRESS_AG: '',
      CITY_AG: '',
      COUNTRY_AG: '1',
      id: 0,
      TEL: '',
      FAX: '',
      EMAIL: '',
      SITE_WEB: ''
    });
  };

  cov_10r43dfprg.s[20]++;
  $scope.params = {
    toolbar: $rootScope.currentRight.u ? (cov_10r43dfprg.b[2][0]++, ['Add']) : (cov_10r43dfprg.b[2][1]++, undefined),
    editSettings: { allowEditing: true, allowAdding: true, allowDeleting: true, allowEditOnDblClick: false },
    columns: [{ field: 'NAME_AG', headerText: $translate.instant('AGENCIES.NAME'), type: 'string', clipMode: 'EllipsisWithTooltip' }, { field: 'SHORT_NAME_AG', width: 170, headerText: $translate.instant('AGENCIES.SHORT_NAME'), type: 'string', clipMode: 'EllipsisWithTooltip' }, { field: 'ADDRESS_AG', width: 150, headerText: $translate.instant('AGENCIES.ADDRESS'), type: 'string', clipMode: 'EllipsisWithTooltip' }, { field: 'CITY_AG', width: 120, headerText: $translate.instant('AGENCIES.CITY'), type: 'string', clipMode: 'EllipsisWithTooltip' }, { field: 'TEL', width: 120, headerText: $translate.instant('AGENCIES.TEL'), type: 'string', clipMode: 'EllipsisWithTooltip' }, { field: 'FAX', width: 120, headerText: $translate.instant('AGENCIES.FAX'), type: 'string', clipMode: 'EllipsisWithTooltip' }, { field: 'EMAIL', width: 150, headerText: $translate.instant('AGENCIES.EMAIL'),

      template: '<div>${if(EMAIL)}<a href="mailto: ${EMAIL}" target="_blank" >${EMAIL}</a> ${else} <span> </span>${/if}</div>',
      type: 'string', clipMode: 'EllipsisWithTooltip' }, { field: 'SITE_WEB', width: 150, headerText: $translate.instant('AGENCIES.URL'), type: 'string',

      template: '<div>${if(SITE_WEB)}<a href="${SITE_WEB}" target="_blank" >${SITE_WEB}</a> ${else} <span> </span>${/if}</div>',
      clipMode: 'EllipsisWithTooltip' }, { headerText: '', width: 120,
      commands: [].concat($rootScope.currentRight.u ? (cov_10r43dfprg.b[3][0]++, [{ type: 'Edit', buttonOption: { iconCss: ' e-icons e-edit', cssClass: 'e-flat' } }]) : (cov_10r43dfprg.b[3][1]++, [])).concat($rootScope.currentRight.d ? (cov_10r43dfprg.b[4][0]++, [{ type: 'Delete', buttonOption: { iconCss: 'e-icons e-delete', cssClass: 'e-flat' } }]) : (cov_10r43dfprg.b[4][1]++, []))
    }],
    actionBegin: function actionBegin(action) {
      cov_10r43dfprg.s[21]++;

      if (action.requestType === 'add') {
        cov_10r43dfprg.b[5][0]++;
        cov_10r43dfprg.s[22]++;

        action.cancel = true;
        cov_10r43dfprg.s[23]++;
        $scope.add();
      } else {
        cov_10r43dfprg.b[5][1]++;
      }
      cov_10r43dfprg.s[24]++;
      if (action.requestType === 'beginEdit') {
        cov_10r43dfprg.b[6][0]++;
        cov_10r43dfprg.s[25]++;

        action.cancel = true;
        cov_10r43dfprg.s[26]++;
        $scope.editItem(action.rowData);
      } else {
        cov_10r43dfprg.b[6][1]++;
      }
      cov_10r43dfprg.s[27]++;
      if (action.requestType === 'delete') {
        cov_10r43dfprg.b[7][0]++;
        cov_10r43dfprg.s[28]++;

        action.cancel = true;
        cov_10r43dfprg.s[29]++;
        $scope.deleteItem(action.data[0]);
      } else {
        cov_10r43dfprg.b[7][1]++;
      }
    }
  };

  cov_10r43dfprg.s[30]++;
  $scope.editItem = function (item) {
    cov_10r43dfprg.f[5]++;
    cov_10r43dfprg.s[31]++;

    $scope.error_code = false;
    cov_10r43dfprg.s[32]++;


    $scope.selectedItemAgencies = angular.copy(item);
    cov_10r43dfprg.s[33]++;
    $scope.selectedItemAgencies.COUNTRY_AG = $scope.countries.find(function (country) {
      cov_10r43dfprg.f[6]++;
      cov_10r43dfprg.s[34]++;
      return item.COUNTRY_AG == country.id;
    });

    cov_10r43dfprg.s[35]++;
    $uibModal.open({
      templateUrl: 'app/views/agencies/edit.html',
      controller: AgenciesCtrl_edit,
      scope: $scope,
      size: 'sm_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_10r43dfprg.s[36]++;
  $scope.deleteItem = function (item) {
    cov_10r43dfprg.f[7]++;
    cov_10r43dfprg.s[37]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_10r43dfprg.f[8]++;
      cov_10r43dfprg.s[38]++;

      if (isconfirm) {
        cov_10r43dfprg.b[8][0]++;
        cov_10r43dfprg.s[39]++;

        return;
      } else {
        cov_10r43dfprg.b[8][1]++;
      }
      cov_10r43dfprg.s[40]++;
      $scope.isloading = true;
      cov_10r43dfprg.s[41]++;
      $CRUDService.delet(PATH, { action: 'supp', id: item.id }, function (data) {
        cov_10r43dfprg.f[9]++;
        cov_10r43dfprg.s[42]++;

        if (data < 0) {
          cov_10r43dfprg.b[9][0]++;
          cov_10r43dfprg.s[43]++;

          $scope.isloading = false;
          cov_10r43dfprg.s[44]++;
          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
          });

          cov_10r43dfprg.s[45]++;
          return;
        } else {
          cov_10r43dfprg.b[9][1]++;
        }
        cov_10r43dfprg.s[46]++;
        $scope.getAll();
      });
    });
  };

  cov_10r43dfprg.s[47]++;
  $scope.getAll();
});

function AgenciesCtrl_edit($scope, $uibModalInstance, $filter, $CRUDService) {
  cov_10r43dfprg.f[10]++;
  cov_10r43dfprg.s[48]++;


  $scope.error_code = false;
  var PATH = (cov_10r43dfprg.s[49]++, 'AgenciesProject');
  cov_10r43dfprg.s[50]++;
  $scope.setValidData = function () {
    cov_10r43dfprg.f[11]++;

    var validateItem = (cov_10r43dfprg.s[51]++, angular.copy($scope.selectedItemAgencies));
    cov_10r43dfprg.s[52]++;
    $scope.error_code = {};
    var items = (cov_10r43dfprg.s[53]++, $filter('filter')($scope.data, { NAME_AG: validateItem.NAME_AG }, true));
    cov_10r43dfprg.s[54]++;
    for (var _iterator2 = items, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var item = _ref2;
      cov_10r43dfprg.s[55]++;

      if ((cov_10r43dfprg.b[11][0]++, item) && (cov_10r43dfprg.b[11][1]++, item.id != validateItem.id)) {
        cov_10r43dfprg.b[10][0]++;
        cov_10r43dfprg.s[56]++;

        $scope.error_code.name = true;
        cov_10r43dfprg.s[57]++;
        return;
      } else {
        cov_10r43dfprg.b[10][1]++;
      }
    }
    cov_10r43dfprg.s[58]++;
    validateItem.COUNTRY_AG = validateItem.COUNTRY_AG.id;
    cov_10r43dfprg.s[59]++;
    $CRUDService.save(PATH, { action: 'MiseAJour', valeur: $filter('json')(validateItem) }, function () {
      cov_10r43dfprg.f[12]++;
      cov_10r43dfprg.s[60]++;

      $scope.closeModal();
      cov_10r43dfprg.s[61]++;
      $scope.getAll();
    });
  };
  cov_10r43dfprg.s[62]++;
  $scope.closeModal = function () {
    cov_10r43dfprg.f[13]++;
    cov_10r43dfprg.s[63]++;

    $uibModalInstance.dismiss('cancel');
  };
}